import graphqlClient from "../../api/axios_interceptor";
import { initializePaystackTransactionMutation, cancelCardSubscriptionMutation } from "../../api/graphql/queries/paystack";
import { INITIALIZE_PAYSTACK_TRANSACTION, CANCEL_CARD_SUBSCRIPTION } from "../actions/actionTypes";
import { updateActionErrors } from "./updateErrors";

const initializeTransactionMiddleware = async (action) => {
    try {
        await graphqlClient({
            data: {
                query: initializePaystackTransactionMutation(action.payload)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.initializeTransaction.error) {
                action = updateActionErrors(action, queryResult.data.data.initializeTransaction.error);
            } else{
                let result = queryResult.data.data.initializeTransaction;
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        accessCode: result.accessCode
                    }
            }
        }
        });
    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error)
    }

    return action;
}

const cancelCardSubscriptionMiddleware = async (action) => {
    try {
        await graphqlClient({
            data: {
                query: cancelCardSubscriptionMutation()
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (!queryResult.data.data.cancelCardSubscription.success) {
                action = updateActionErrors(action, queryResult.data.data.cancelCardSubscription.message);
            } else{
                let result = queryResult.data.data.cancelCardSubscription;
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        message: result.message
                    }
            }
        }
        });
    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error)
    }

    return action;
}

export const paystackMiddleware = storeAPI => next => async action => {
    switch(action.type){
        case INITIALIZE_PAYSTACK_TRANSACTION:
            action = await initializeTransactionMiddleware(action);
            break;
        case CANCEL_CARD_SUBSCRIPTION:
            action = await cancelCardSubscriptionMiddleware(action);
            break;
    }
    return next(action);
}